declare let $2sxc: any;

import { UiActions } from './add-ins/uiActions';
import { CollectFieldsManual } from './collect-fields/manual';
import { CollectFieldsAutomatic } from './collect-fields/auto';
import { Recaptcha } from './add-ins/recaptcha';
export class App {
  helperFunc = new UiActions();
  collectFieldsManual = new CollectFieldsManual();
  collectFieldsAutomatic = new CollectFieldsAutomatic();
  recaptcha = new Recaptcha();
  moduleWrapper: JQuery;
  alreadyInit = false;

  c = {
    clsWrp: 'app-jqfs-wrapper',
    clsForm: 'app-jqfs-form',
  };

  constructor(
    moduleId: number,
  ) {
    // disable validate on the global asp.net form, to not interfere with the contact-form
    $('form').attr('novalidate', '');
    this.moduleWrapper = $(`#dnn_ctr${moduleId}_ModuleContent`);
  }

  public initialize() {
    const wrapper = this.moduleWrapper;
    const urlHash = location.hash;
    // attach validation to enable as soon as we blur        
    wrapper.on('blur', ':input', this.helperFunc.attachFieldValidateOnBlur);

    wrapper.each((i, item) => {
      // prevent dupl execution
      if (this.alreadyInit)
        return;

      const wrap = $(item);
      wrap.find('#sendFormWithApi').on('click', (evt: JQueryEventObject) => this.send(evt)); // handle click event
      this.recaptcha.init(wrap);

      this.alreadyInit = true;
    });

    wrapper.find('[data-radio-content]').on('change', (evt: JQueryEventObject) => this.changeContent(evt));

    wrapper.find('.form-control-file').on("change", (evt: any) => {
      const fileName = evt.target.files[0].name;
      wrapper.find('.file-name').text(fileName);
    });

    wrapper.find('.info-link').on('click', (evt: JQueryEventObject) => this.helperFunc.showInfo(evt));
    wrapper.find('.close-form-info').on('click', (evt: JQueryEventObject) => this.helperFunc.hideInfo(evt));
    wrapper.find('.form-info-overlay').on('click', (evt: JQueryEventObject) => this.helperFunc.hideInfo(evt));

    $('[data-toggle="tab"]').on('click', (evt: JQueryEventObject)  => this.puhsHistory(evt));

    if(urlHash.indexOf("entity-")) {
      setTimeout(() => {
        $(`[href="${urlHash}"]`).click();
        if (urlHash != '') {
          $('html,body').scrollTop($(`[href="${urlHash}"]`).offset().top - 70);
        }
      }, 1000) 
    }
  }

  public changeContent(event: JQueryEventObject) {
    const curTarget = event.currentTarget;
    const curData = $(curTarget).data('radio-content');

    $('.radio-select').hide();
    $(`[data-radio-select*="${curData}"]`).show();
  }

  public puhsHistory(event: JQueryEventObject) {
    const curTarget = event.currentTarget;
    const curHref = $(curTarget).attr('href');
    const curName = $(curTarget).text();

    if(location.hash != curHref) {
      var stateObj = { page: curName };
      history.pushState(stateObj, curName, curHref);
    }
  }

  public async send(event: JQueryEventObject) {
    const btn = event.currentTarget;
    const sxc = $2sxc(btn);
    const wrapper = this.moduleWrapper;
    let hasError = false;

    // clear all alerts
    this.helperFunc.showOneAlert(wrapper, '');

    if(wrapper.find('.special-email-validation').length > 0) {
      const regExMail = /\@(googlemail|gmail|hotmail|yahoo|outlook|icloud)([\.])/g;
      const emailValue = $('.special-email-validation').val().toString();

      if(regExMail.test(emailValue)){
        const parentRow = wrapper.find('.special-email-validation').parents('.form-group');
        parentRow.addClass('has-feedback has-error');
        parentRow.find('.form-info').show();
        return this.helperFunc.showOneAlert(wrapper, 'msgIncomplete');
      }
    }
    if($(wrapper).find('.app-jqfs-wrapper-proposal').length == 1) {
      $('label').removeClass('label-error');
      
      if($('input.required-what:checked').length == 0) {
        $('label.required-what').addClass('label-error');
        hasError = true;
      }

      if($('input.required-where:checked').length == 0) {
        $('label.required-where').addClass('label-error');
        hasError = true;
      }
    }

    if($(wrapper).find('input.ohnohoney').length == 1 && $(wrapper).find('input.ohnohoney').val() != "") {
      return false;
    }

    // Validate form
    if (!(wrapper as any).smkValidate() || hasError)
      return this.helperFunc.showOneAlert(wrapper, 'msgIncomplete');

    // Get a recaptcha token which will be sent along with the request
    const recap_v2_token = await this.recaptcha.checkV2(wrapper);
    if (!recap_v2_token)
      return this.helperFunc.showOneAlert(wrapper, 'msgRecap');
    console.log("Recaptcha v2 token was ", recap_v2_token);
    

    // Get a recaptcha token which will be sent along with the request
    const recap_token = await this.recaptcha.check(wrapper);
    if (!recap_token)
      return this.helperFunc.showOneAlert(wrapper, 'msgRecap');
    console.log("Recaptcha token was ", recap_token);

    // get data 
    // alternative example with manual build, but we prefer automatic
    // let data;
    // data = this.collectFieldsManual.collect(wrapper);
    this.collectFieldsAutomatic.collect(wrapper).then((data: any) => {
      const ws = wrapper.find('.app-jqfs-wrapper').data('webservice'); // should be "Form/ProcessForm" or a custom override
      const redirectUrl = wrapper.find('.app-jqfs-wrapper').data('redirect');
      data.Recaptcha = recap_token;
      data.MailChimp = wrapper.find('[name="SenderNewsletter"]:checked').length ? "True" : "False";

      // submission
      this.helperFunc.disableInputs(wrapper, true);
      this.helperFunc.showOneAlert(wrapper, 'msgSending'); // show "sending..."

      sxc.webApi.post(ws, {}, data, true)
        .success(() => {
          if(redirectUrl != "") {
            window.location.href = redirectUrl;
          } else {
            const msg = wrapper.find('[name="SenderNewsletter"]:checked').length ? 'msgNewsletterSuccess' : 'msgOk';
            this.helperFunc.showOneAlert(wrapper, msg);
          }
        })
        .error(() => {
          const msg = wrapper.find('[name="SenderNewsletter"]:checked').length ? 'msgNewsletterFailed' : 'msgError';
          this.helperFunc.showOneAlert(wrapper, msg);
          this.helperFunc.disableInputs(wrapper, false);
        });
    });
  }
}